import React from "react";
import RemoteTable from "../../../components/ui/RemoteTable";
import { printFullDate } from "../../../utils/time";
import payment from "../../../services/paymentServices";
import modal from "../../../services/modalServices";
import Button from "../../../components/ui/Button";
import { useLanguage } from "../../../context/LanguageContext";

const UserWalletInvoicesTable = () => {
    const { language } = useLanguage();

    const content = {
        columns: {
            sequence: { en: "Sequence", ar: "التسلسل", de: "Sequenz" },
            totalPrice: {
                en: "Total Invoice Price",
                ar: "اجمالي سعر الفاتورة",
                de: "Gesamtrechnungsbetrag",
            },
            paymentStatus: { en: "Payment Status", ar: "حالة الدفع", de: "Zahlungsstatus" },
            paymentTime: { en: "Payment Time", ar: "وقت الدفع", de: "Zahlungszeit" },
            paymentMethod: { en: "Payment Method", ar: "طريقة الدفع", de: "Zahlungsmethode" },
            invoiceId: { en: "Invoice ID", ar: "رقم الفاتورة", de: "Rechnungs-ID" },
            invoiceCreationTime: {
                en: "Invoice Creation Time",
                ar: "وقت انشاء الفاتورة",
                de: "Rechnungserstellungszeit",
            },
        },
        paid: { en: "Paid", ar: "مدفوع", de: "Bezahlt" },
        unpaid: { en: "Unpaid", ar: "لم يتم الدفع", de: "Unbezahlt" },
        unpaidWarning: { en: "-- Not Paid --", ar: "--لم يتم الدفع--", de: "-- Nicht bezahlt --" },
        fawryMessage: {
            en: (ref) =>
                `Your reference number is: ${ref}. Go to the nearest Fawry service point and pay using service code 788.`,
            ar: (ref) =>
                `رقمك المرجعي هو : ${ref} , \n توجه نحو اقرب فرع خدمة لفوري و اطلب الدفع على خدمة رقم ٧٨٨ بهذا الكود المرجعي`,
            de: (ref) =>
                `Ihre Referenznummer lautet: ${ref}. Gehen Sie zur nächsten Fawry-Service-Stelle und bezahlen Sie mit dem Service-Code 788.`,
        },
    };

    let columns = [
        {
            name: content.columns.sequence[language],
            reorder: true,
            selector: (row) => row.id,
            sortable: true,
            sortField: "id",
        },
        {
            name: content.columns.totalPrice[language],
            reorder: true,
            selector: (row) => row.total_price,
            sortable: true,
            sortField: "price",
        },
        {
            name: content.columns.paymentStatus[language],
            reorder: true,
            selector: (row) => (
                <>
                    {row.invoice_provider === "fawry_ref" ? (
                        <div>
                            <Button
                                color={row.invoice_status === "paid" ? "cyan" : "rose"}
                                onClick={() =>
                                    modal.message({
                                        title: content.columns.paymentStatus[language],
                                        text: content.fawryMessage[language](row.reference_number),
                                    })
                                }
                            >
                                {row.invoice_status === "paid"
                                    ? content.paid[language]
                                    : content.unpaid[language]}
                            </Button>
                        </div>
                    ) : (
                        <div>
                            <a
                                target="_blank"
                                rel="noreferrer"
                                href={payment.getInvoiceUrl(row)}
                                className="underline"
                            >
                                {row.invoice_status === "paid" ? (
                                    <div className="py-1 px-2 rounded-md bg-cyan-500 clr-white">
                                        {content.paid[language]}
                                    </div>
                                ) : (
                                    <div className="py-1 px-2 rounded-md bg-rose-500 clr-white">
                                        {content.unpaid[language]}
                                    </div>
                                )}
                            </a>
                        </div>
                    )}
                </>
            ),
            sortable: true,
            sortField: "invoice_status",
        },
        {
            name: content.columns.paymentTime[language],
            reorder: true,
            selector: (row) =>
                row.invoice_status === "paid" ? (
                    row.payment_time ? (
                        printFullDate(row.payment_time)
                    ) : (
                        "--"
                    )
                ) : (
                    <div className="text-yellow-500">{content.unpaidWarning[language]}</div>
                ),
            sortable: true,
            sortField: "payment_time",
        },
        {
            name: content.columns.paymentMethod[language],
            reorder: true,
            selector: (row) =>
                row.invoice_status === "paid" ? (
                    row.payment_method
                ) : (
                    <div className="text-yellow-500">{content.unpaidWarning[language]}</div>
                ),
            sortable: true,
            sortField: "payment_method",
        },
        {
            name: content.columns.invoiceId[language],
            reorder: true,
            selector: (row) => <div>{row.invoice_id}</div>,
            sortable: true,
            sortField: "invoice_id",
        },
        {
            name: content.columns.invoiceCreationTime[language],
            reorder: true,
            selector: (row) => printFullDate(row.created_at),
            sortable: true,
            sortField: "created_at",
        },
    ];

    return (
        <div>
            <div className="w-full">
                <RemoteTable
                    isAdmin={false}
                    api={`/api/user/wallet_invoices/paginate`}
                    columns={columns}
                />
            </div>
        </div>
    );
};

export default UserWalletInvoicesTable;
